export default __webpack_public_path__ + "static/media/bgEmpresas.db97d844.png";